import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.filter.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SearchForm from '@/components/TimedTaskSearchForm';
import NoData from '@/components/NoData/NoData';
import { valsubstr32addbr } from '@/utils';
export default {
  components: {
    SearchForm: SearchForm,
    NoData: NoData
  },
  data: function data() {
    return {
      searchFormData: [{
        title: '系统名称',
        key: 'sysName',
        placeholder: '请选择系统名称',
        type: 'select',
        value: '',
        selectData: [],
        selectedArr: ''
      }, {
        title: '任务组名称',
        key: 'TriggerGroupName',
        placeholder: '请输入任务组名称',
        type: 'input',
        value: '',
        selectData: [],
        selectedArr: []
      }, {
        title: '任务名称',
        key: 'TriggerName',
        placeholder: '请输入任务名称',
        type: 'input',
        value: '',
        selectData: [],
        selectedArr: []
      }],
      btnType: 'add,search,reset',
      tableData: [],
      dialogVisible: false,
      delDialog: false,
      specificUserForm: {
        systemId: '',
        // 系统名称
        jobName: '',
        // 定时器名
        jobGroup: '',
        // 定时器分组
        jobClass: '',
        // 执行类
        description: '',
        // 描述
        cronExpression: '' // cron表达式
      },

      specificUserRules: {
        systemId: [{
          required: true,
          message: '请选择子系统名称',
          trigger: 'change'
        }],
        jobGroup: [{
          required: true,
          message: '请输入任务组名称',
          trigger: 'blur'
        }],
        jobName: [{
          required: true,
          message: '请输入任务名称',
          trigger: 'blur'
        }],
        jobClass: [{
          required: true,
          message: '请输入执行类',
          trigger: 'blur'
        }],
        cronExpression: [{
          required: true,
          message: '请输入Cron',
          trigger: 'blur'
        }]
      },
      addFlage: false,
      editFlage: false,
      systemList: [],
      pageNum: 1,
      pageSize: 10,
      total: 0,
      rowData: '',
      isEdit: false,
      isDel: false,
      isOption: '',
      loading: false,
      tableheight: 580,
      pageshow: true
    };
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      this.tableheight = window.innerHeight - 352;

      // 监听窗口大小变化
      var self = this;
      window.onresize = function () {
        self.tableheight = window.innerHeight - 352;
      };
    });
    this.searchForm(this.$refs.searchForm.formData);
  },
  methods: {
    currentChange: function currentChange(num) {
      this.pageNum = num;
      this.searchForm(this.searchFormData);
    },
    sizeChange: function sizeChange(val) {
      this.pageSize = val;
      this.searchForm(this.searchFormData);
    },
    btnConfirm: function btnConfirm(val) {
      if (this.rowData === '') {
        this.$message({
          message: '请先选择需要操作的任务',
          type: 'warning'
        });
        return;
      }
      this.isOption = val;
      this.delDialog = true;
    },
    confirmBtn: function confirmBtn() {
      this[this.isOption]();
    },
    recovery: function recovery(scope) {
      var _this = this;
      this.$refs["timetask-".concat(scope.row.systemId).concat(scope.row.jobName).concat(scope.row.jobGroup)].doClose();
      this.$API.postRequest({
        url: '/platform/scheduler/resume',
        data: {
          jobGroup: scope.row.jobGroup,
          jobName: scope.row.jobName,
          systemId: scope.row.systemId
        }
      }).then(function (res) {
        if (res.code === '0000000000') {
          _this.$message({
            message: '任务恢复成功',
            type: 'success'
          });
          _this.searchForm(_this.$refs.searchForm.formData);
        }
      });
    },
    pause: function pause(scope) {
      var _this2 = this;
      this.$refs["timetask-".concat(scope.row.systemId).concat(scope.row.jobName).concat(scope.row.jobGroup)].doClose();
      this.isOption = 'pause';
      this.$API.postRequest({
        url: '/platform/scheduler/pause',
        data: {
          jobGroup: scope.row.jobGroup,
          jobName: scope.row.jobName,
          systemId: scope.row.systemId
        }
      }).then(function (res) {
        if (res.code === '0000000000') {
          _this2.$message({
            message: '任务暂停成功',
            type: 'success'
          });
          _this2.searchForm(_this2.$refs.searchForm.formData);
          _this2.delDialog = false;
        }
      });
    },
    manualForm: function manualForm(scope) {
      var _this3 = this;
      this.$refs["timetask-".concat(scope.row.systemId).concat(scope.row.jobName).concat(scope.row.jobGroup)].doClose();
      this.$API.postRequest({
        url: '/platform/scheduler/exec',
        data: {
          jobGroup: scope.row.jobGroup,
          jobName: scope.row.jobName,
          systemId: scope.row.systemId
        }
      }).then(function (res) {
        if (res.code === '0000000000') {
          _this3.$message({
            message: '手动触发任务成功',
            type: 'success'
          });
          _this3.searchForm(_this3.$refs.searchForm.formData);
        }
      });
    },
    searchForm: function searchForm(obj) {
      var _this4 = this;
      this.loading = true;
      this.$API.postRequest({
        url: '/platform/scheduler/list',
        data: {
          jobGroup: obj[1].value,
          jobName: obj[2].value,
          systemId: obj[0].selectedArr,
          pageNum: this.pageNum,
          pageSize: this.pageSize
        }
      }).then(function (res) {
        _this4.loading = false;
        if (res.code === '0000000000') {
          // this.loading = false
          _this4.tableData = res.result.records;
          _this4.total = res.result.total;
        }
      });
    },
    resetForm: function resetForm() {
      this.searchFormData[0].selectedArr = '';
      this.searchFormData[1].value = '';
      this.searchFormData[2].value = '';
      this.pageNum = 1;
      this.searchForm(this.$refs.searchForm.formData);
    },
    addTable: function addTable() {
      this.isEdit = false;
      this.specificUserForm.systemId = '';
      this.specificUserForm.jobName = '';
      this.specificUserForm.jobGroup = '';
      this.specificUserForm.jobClass = '';
      this.specificUserForm.description = '';
      this.specificUserForm.cronExpression = '';
      this.dialogVisible = true;
    },
    editForm: function editForm(scope) {
      this.isEdit = true;
      this.$refs["timetask-".concat(scope.row.systemId).concat(scope.row.jobName).concat(scope.row.jobGroup)].doClose();
      this.specificUserForm.systemId = scope.row.systemId;
      this.specificUserForm.jobName = scope.row.jobName;
      this.specificUserForm.jobGroup = scope.row.jobGroup;
      this.specificUserForm.jobClass = scope.row.jobClass;
      this.specificUserForm.description = scope.row.description;
      this.specificUserForm.cronExpression = scope.row.cronExpression;
      this.dialogVisible = true;
    },
    delForm: function delForm() {
      this.delDialog = true;
    },
    handleClose: function handleClose() {
      this.dialogVisible = false;
    },
    submit: function submit() {
      var _this5 = this;
      this.$refs.specificUserForm.validate(function (valid) {
        if (valid) {
          _this5.dialogVisible = false;
          _this5.$API.postRequest({
            url: '/platform/scheduler',
            data: _this5.specificUserForm
          }).then(function (res) {
            if (res.code === '0000000000') {
              _this5.$message({
                message: _this5.isEdit ? '编辑成功' : '新增成功',
                type: 'success'
              });
              _this5.pageshow = false;
              _this5.pageNum = _this5.total % _this5.pageSize === 0 ? Math.ceil(_this5.total / _this5.pageSize) + 1 : Math.ceil(_this5.total / _this5.pageSize);
              _this5.searchForm(_this5.$refs.searchForm.formData);
              _this5.$nextTick(function () {
                _this5.pageshow = true;
              });
            }
          });
        } else {
          _this5.$message({
            message: '请完善信息填写',
            type: 'warning'
          });
          return false;
        }
      });
    },
    delBtn: function delBtn(scope) {
      var _this6 = this;
      var page = Math.ceil(this.total / this.pageSize); // 最大页数
      if (this.pageNum === page) {
        if (this.total % this.pageSize === 1) {
          this.pageNum > 1 ? this.pageNum-- : this.pageNum = 1;
        }
      }
      this.$refs["timetask-".concat(scope.row.systemId).concat(scope.row.jobName).concat(scope.row.jobGroup)].doClose();
      this.$API.delRequest({
        url: '/platform/scheduler',
        data: {
          jobGroup: scope.row.jobGroup,
          jobName: scope.row.jobName,
          systemId: scope.row.systemId
        }
      }).then(function (res) {
        if (res.code === '0000000000') {
          _this6.$message({
            message: '删除成功',
            type: 'success'
          });
          _this6.rowData = '';
          _this6.searchForm(_this6.$refs.searchForm.formData);
        }
      });
      this.delDialog = false;
    },
    delclose: function delclose() {
      this.delDialog = false;
    },
    changePage: function changePage() {},
    rowClick: function rowClick(content) {
      this.rowData = content;
    },
    // tooltips过长换行(length 32换行)
    ToBreak: function ToBreak(val) {
      if (val) {
        return valsubstr32addbr(val);
      }
    },
    headerdragend: function headerdragend(newWidth, oldWidth, column) {
      if (newWidth < column.minWidth) {
        column.width = column.minWidth;
      }
    }
  },
  created: function created() {
    var _this7 = this;
    this.$API.getRequest({
      url: '/platform/systemInner/timedTaskList'
    }).then(function (res) {
      if (res.code === '0000000000') {
        // eslint-disable-next-line array-callback-return
        res.result.filter(function (item) {
          var selectvalue = {
            value: item.systemId,
            label: item.systemName
          };
          _this7.searchFormData[0].selectData.push(selectvalue);
          _this7.systemList.push(selectvalue);
        });
      }
    });
  }
};